import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	jiraSearchWorkItems: {
		id: 'jira_advanced_search',
		defaultMessage: 'Search Jira for work items',
		description: 'Label for when the user wants to navigate to a advanced issue search on Jira',
	},
});
